import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import PersonajesImage from '../../assets/Personajes.png';
import {
  LearnMoreContainer,
  ImageWrapper,
  LearnMoreImage,
  ContentWrapper,
  Description,
  StyledButton,
} from './LearnMore.styles';
import { LearnMoreProps } from './LearnMore.types';

const LearnMore: React.FC<LearnMoreProps> = React.memo(({ className }) => {
  const { t } = useI18n();
  const navigate = useNavigate();

  const handleButtonClick = useCallback(() => {
    navigate('/games');
  }, [navigate]);

  return (
    <LearnMoreContainer className={className}>
      <ImageWrapper>
        <LearnMoreImage src={PersonajesImage} alt="Kimera Characters" />
      </ImageWrapper>
      <ContentWrapper>
        <Description>{t('learnMore.description')}</Description>
        <StyledButton onClick={handleButtonClick}>{t('learnMore.button')}</StyledButton>
      </ContentWrapper>
    </LearnMoreContainer>
  );
});

LearnMore.displayName = 'LearnMore';

export default LearnMore;
